<template>
	<div class="text">
		<div style="text-align:center;font-size:12px;color:#666666;">本版更新时间：2021年10月1日</div>
		<div style="text-align:center;font-size:12px;color:#666666;">本版生效时间：2021年10月1日</div>
		<p class="head">尊敬的用户：</p>
		<p>在您成为消防设施操作员实操仿真学习软件注册用户，使用消防设施操作员实操仿真学习软件提供的服务之前，请您认真阅读本《用户协议》，更好的了解我们所提供的服务以及您享有的权利和承担的义务。您开始使用消防设施操作员实操仿真学习软件提供的服务，即表示您已经确认并接受了本文件中的全部条款。
		</p>
		<p class="head">第一部分 用户协议</p>
		<p>本用户协议（简称“协议”）系由您与上海爻塔科技有限公司（以下简称“本公司”或“我们”）就上海爻塔科技有限公司提供的消防设施操作员实操仿真学习软件软件（以下简称“本平台”或“消防设施操作员实操仿真学习软件”）所订立的相关权利义务规范。消防设施操作员实操仿真学习软件软件是一个严肃纯净的消防实操学习软件，请您在注册、使用消防设施操作员实操仿真学习软件之前，应认真阅读以下条款：
		</p>
		<p class="head">一、注册条款的接受</p>
		<p>一旦您在注册页面点击或勾选“阅读并同意接受用户协议及隐私政策”相关内容后，即表示您已经阅读并且同意与本公司达成协议，成为消防设施操作员实操仿真学习软件的用户，并接受本用户协议中的全部注册条款以及第二部分消防设施操作员实操仿真学习软件《个人信息保护政策》和消防设施操作员实操仿真学习软件软件内公布的其他规定的所有条款的约束。
		</p>
		<p class="head">二、用户注册条件</p>
		<p>1.申请注册成为消防设施操作员实操仿真学习软件的用户应同时满足下列全部条件：在注册之日以及此后使用消防设施操作员实操仿真学习软件服务期间必须以学习为目的；在注册之日必须年满18周岁以上。</p>
		<p>2.为更好的享有消防设施操作员实操仿真学习软件的网络平台服务，用户应遵守消防设施操作员实操仿真学习软件软件注册机制的要求，向消防设施操作员实操仿真学习软件提供本人真实、正确、最新及完整的资料。
		</p>
		<p>3.若用户提供任何错误、不实或不完整的资料，或消防设施操作员实操仿真学习软件有理由怀疑资料为错误、不实或不完整及违反用户注册条款的，或消防设施操作员实操仿真学习软件有理由怀疑其用户资料、言行等，消防设施操作员实操仿真学习软件有权修改用户的注册昵称、个人说明、发布的信息等，或暂停或终止该用户的帐号，或暂停或终止提供消防设施操作员实操仿真学习软件提供的全部或部分服务。
		</p>
		<p>4.若用户故意提供虚假的身份信息、公司信息进行注册，视为严重违反本用户协议，消防设施操作员实操仿真学习软件有权暂停或终止该用户账号并停止提供服务。虚假注册、发布虚假信息给消防设施操作员实操仿真学习软件造成经济、名誉损失的，消防设施操作员实操仿真学习软件将追究该用户的法律责任。
		</p>
		<p class="head">三、用户帐号、手机验证码及安全</p>
		<p>1.在完成用户注册程序之后，用户通过手机号验证码登录。用户有义务保证不随意泄露登录验证码及帐号的安全。用户应对利用该帐号所进行的一切活动负全部责任，包括任何经由消防设施操作员实操仿真学习软件上传、张贴、发送电子邮件或任何其它方式传送的资讯、资料、文字、软件、音乐、音讯、照片、图形、视讯、信息或其它资料，无论系公开还是私下传送，均由内容提供者承担责任。
		</p>
		<p>2.用户的帐号遭到未获授权的使用，或者发生其它任何安全问题时，用户应立即通知消防设施操作员实操仿真学习软件。由于用户使用不当或者其他非因消防设施操作员实操仿真学习软件导致的帐号、登录验证码泄漏，进而导致其资料、信息泄漏的，由用户承担其不利后果。</p>
		<p>3.用户不得将账号主动告知第三方或提供给第三方进行使用，例如提供给第三方进行代为购买消防设施操作员实操仿真学习软件服务等。如因此造成用户隐私泄露或消防设施操作员实操仿真学习软件平台损失的，用户应当承担相应的责任。</p>
		<p class="head">四、服务说明</p>
		<p>1.消防设施操作员实操仿真学习软件通过国际互联网为用户提供网络服务，包括在线及离线的相关业务。为使用网络服务，用户应自行配备进入国际互联网所必需的设备，包括计算机、数据机或其它存取装置，并自行支付登陆国际互联网所需要的费用。</p>
		<p>2.消防设施操作员实操仿真学习软件在提供网络服务时，可能会对部分网络服务收取一定的费用，在此情况下，会在相关页面上做明确的提示。如用户拒绝支付该等费用，则不能使用相关的网络服务。付费业务将在本注册条款的基础上另行规定服务条款，以规范付费业务的内容和双方的权利义务，用户应认真阅读，如用户购买付费业务，则视为接受付费业务的服务条款。
		</p>
		<p>3.无论是付费服务还是消防设施操作员实操仿真学习软件的免费服务均有有效期，有效期结束后服务将自动终止，且有效期不可中断或延期。除非本注册条款或其他相关服务条款另有规定，所有付费业务均不退费。</p>
		<p>4.对于利用消防设施操作员实操仿真学习软件进行非法活动，或其言行（无论线上或者线下的）背离消防设施操作员实操仿真学习软件学习目的的，消防设施操作员实操仿真学习软件将严肃处理，包括将其列入黑名单、将其被投诉的情形公之于众、删除用户帐号等处罚措施，给消防设施操作员实操仿真学习软件造成经济或者名誉损失的，消防设施操作员实操仿真学习软件将追究其法律责任。
		</p>
		<p>5.消防设施操作员实操仿真学习软件有权向其用户发送广告信，或为活动等目的，向其用户发送电子邮件、短信或电话通知。除系统通知或重要信息外，用户可以通过消防设施操作员实操仿真学习软件提供的方式选择不接收上述信息。</p>
		<p>6.消防设施操作员实操仿真学习软件的道具等服务只在产品平台上或由消防设施操作员实操仿真学习软件直接对外出售或者赠送使用权，用户不得在任何其他平台或渠道购买消防设施操作员实操仿真学习软件的虚拟产品或服务。对于用户使用非官方提供或者售卖的道具等虚拟产品或服务造成经济等损失的情况，消防设施操作员实操仿真学习软件不对其负责；如因通过其他平台或他人代充等方式给消防设施操作员实操仿真学习软件造成损失的，用户应当承担违约责任并赔偿损失。
		</p>
		<p>7.用户应通过消防设施操作员实操仿真学习软件软件使用相关服务，未经许可，不得通过其他第三方工具或运营平台获取消防设施操作员实操仿真学习软件服务，包括但不限于通过第三方软件登录消防设施操作员实操仿真学习软件账号。如因用户使用第三方软件导致相关信息泄漏的，消防设施操作员实操仿真学习软件不承担任何责任，且用户还应承担由此给消防设施操作员实操仿真学习软件造成的损失。
		</p>
		<p class="head">五、有限责任条款</p>
		<p>1.本公司将尽力为用户提供提供安全、及时、准确、高质量的服务，但不保证一定能满足用户的要求和期望，也不保证服务不会中断，对服务的及时性、安全性、准确性都不作保证。除非另有约定，否则用户因无法使用消防设施操作员实操仿真学习软件服务，或使用网站服务未达到心理预期的，消防设施操作员实操仿真学习软件不承担责任。
		</p>
		<p>2.对于用户通过本公司提供的服务传送的内容，消防设施操作员实操仿真学习软件会尽合理努力按照国家有关规定严格审查，但无法完全控制经由软件/网站服务传送的内容，不保证内容的正确性、完整性或品质。因此用户在使用消防设施操作员实操仿真学习软件服务时，可能会接触到令人不快、不适当或令人厌恶的内容。在任何情况下，消防设施操作员实操仿真学习软件均不为用户经由软件/网站服务以张贴、发送电子邮件或其它方式传送的任何内容负责。但消防设施操作员实操仿真学习软件有权依法停止传输任何前述内容并采取相应行动，包括但不限于暂停用户使用软件/网站服务的全部或部分，保存有关记录，并根据国家法律法规、相关政策在必要时向有关机关报告并配合有关机关的行动。
		</p>
		<p>3.对于消防设施操作员实操仿真学习软件提供的各种第三方广告信息、链接、资讯等（如有），消防设施操作员实操仿真学习软件不保证其内容的正确性、合法性或可靠性，相关责任由广告主承担；并且，对于用户经由消防设施操作员实操仿真学习软件服务与广告主进行联系或商业往来，完全属于用户和广告主之间的行为，与消防设施操作员实操仿真学习软件无关。对于前述商业往来所产生的任何损害或损失，消防设施操作员实操仿真学习软件不承担任何责任。
		</p>
		<p>4.对于用户上传的照片、资料、证件、视频、内容及图片等，消防设施操作员实操仿真学习软件已采用相关措施并已尽合理努力进行审核，但不保证其内容的正确性、合法性或可靠性，相关责任由上传上述内容的用户承担。</p>
		<p>5.用户应对消防设施操作员实操仿真学习软件上的其他用户发布的内容自行加以判断，并承担因使用内容而引起的所有风险，包括但不限于因对内容的正确性、完整性或实用性的依赖而产生的风险。本公司无法且不会对因前述风险而导致的任何损失或损害承担责任。
		</p>
		<p>6.是否使用软件/网站服务下载或取得任何资料应由用户自行考虑并自负风险，因任何资料的下载而导致的用户电脑系统的任何损坏或数据丢失等后果，消防设施操作员实操仿真学习软件不承担任何责任。</p>
		<p>7.对于用户的投诉，消防设施操作员实操仿真学习软件将尽合理努力进行核实和处理，但不保证一定能满足投诉者的要求。消防设施操作员实操仿真学习软件有权决定是否向公众或向被投诉者公开投诉内容。对于投诉内容侵犯用户隐私权、名誉权等合法权利的，所有法律责任由投诉者承担，与消防设施操作员实操仿真学习软件无关。
		</p>
		<p class="head">六、用户权利</p>
		<p>用户对于自己的个人信息享有以下权利：</p>
		<p>1.随时查询及请求阅览，但因极少数特殊情况（如平台被加入黑名单等）无法查询及提供阅览的除外；</p>
		<p>2.随时请求补充或更正，但因极少数特殊情况（如平台或有关机关为司法程序保全证据等）无法补充或更正的除外；</p>
		<p>3.随时请求注销消防设施操作员实操仿真学习软件账号。关于注销帐号的相关规则和流程，请参见《用户注销协议》。您注销成功后，我们将根据法律法规的要求尽快删除您的个人信息或作匿名化处理。</p>
		<p class="head">七、用户应承诺其平台使用行为遵守以下规定</p>
		<p>1.本协议所称“平台使用”是指用户使用消防设施操作员实操仿真学习软件平台服务所进行的任何行为，包括但不限于注册、登录在消防设施操作员实操仿真学习软件平台所进行的一切行为。</p>
		<p>2.本公司提醒用户在使用消防设施操作员实操仿真学习软件服务时，应遵守《中华人民共和国合同法》、《中华人民共和国著作权法》、《全国人民代表大会常务委员会关于维护互联网安全的决定》、《中华人民共和国保守国家秘密法》、《中华人民共和国电信条例》、《中华人民共和国计算机信息系统安全保护条例》、《中华人民共和国计算机信息网络国际联网管理暂行规定》及其实施办法、《计算机信息系统国际联网保密管理规定》、《互联网信息服务管理办法》、《计算机信息网络国际联网安全保护管理办法》、《互联网电子公告服务管理规定》、《网络安全法》、《中华人民共和国劳动法》及《中华人民共和国劳动合同法》等相关中国法律法规的规定。
		</p>
		<p>3.在任何情况下，如果本公司有理由认为用户使用消防设施操作员实操仿真学习软件服务过程中的任何行为，包括但不限于用户的任何言论和其它行为违反或可能违反上述法律和法规的任何规定，本公司可在任何时候不经任何事先通知终止向该用户提供服务。
		</p>
		<p>4.用户承诺在使用消防设施操作员实操仿真学习软件软件期间，遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等【七条底线】</p>
		<p>5.您理解并同意，消防设施操作员实操仿真学习软件平台仅为用户提供消防实操机型模拟的平台，您必须为自己的注册、认证账号下的一切行为负责，包括您所发表的任何内容以及由此产生的任何后果。
		</p>
		<p class="head">八、禁止用户利用消防设施操作员实操仿真学习软件从事下列行为</p>
		<p>通过消防设施操作员实操仿真学习软件的服务时在消防设施操作员实操仿真学习软件的网页上或者利用消防设施操作员实操仿真学习软件的服务制作、复制、发布、传播违反国家相关法律法规及「七条底线」、「九不准」管理规定的违法和不良信息，主要表现为：</p>
		<p>1.反对宪法所确定的基本原则的；</p>
		<p>2.危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
		<p>3.损害国家荣誉和利益的；煽动民族仇恨、民族歧视、破坏民族团结的；</p>
		<p>4.破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
		<p>5.散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
		<p>6.散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
		<p>7.侮辱或者诽谤他人，侵害他人合法权利的；</p>
		<p>8.含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或有悖道德、令人反感的内容；</p>
		<p>9.含有中国法律、法规、规章、条例以及任何具有法律效力的规范所限制或禁止的其它内容的。</p>
		<p>10.使用消防设施操作员实操仿真学习软件服务的过程中，以任何方式危害未成年人的利益。</p>
		<p>11.冒充任何人或机构，包含但不限于冒充消防设施操作员实操仿真学习软件工作人员或以虚伪不实的方式陈述或谎称与任何人或机构有关的。</p>
		<p>12.将侵犯任何人的肖像权、名誉权、隐私权、专权、商标权、著作权、商业秘密或其它专属权利的内容上载、张贴、发送电子邮件或以其它方式传送的。</p>
		<p>13.将病毒或其它计算机代码、档案和程序，加以上载、张贴、发送电子邮件或以其它方式传送的。</p>
		<p>14,跟踪或以其它方式骚扰其他用户的。</p>
		<p>15.未经合法授权而截获、篡改、收集、储存或删除他人个人信息、电子邮件或其它数据资料，或将获知的此类资料用于任何非法或不正当目的。</p>
		<p>16.以任何方式干扰或企图干扰消防设施操作员实操仿真学习软件的任何产品、任何部分或功能的正常运行，或者制作、发布、传播上述工具、方法等。</p>
		<p>17.未能按照消防设施操作员实操仿真学习软件平台的流程、规则进行注册、认证或使用本服务的，违反本服务功能限制或运营策略，或采取任何措施规避前述流程、规则、限制或策略的。</p>
		<p>18.未经本公司的许可使用插件、外挂或通过其他第三方工具、运营平台或任何服务接入本服务和相关系统的。</p>
		<p>19.利用消防设施操作员实操仿真学习软件账号或消防设施操作员实操仿真学习软件平台服务从事，包括但不限于欺诈、传销、刷流量、好评、违法物品营销等任何违法兼职或犯罪活动的。</p>
		<p>20.仿冒、混淆他人账号昵称、头像的。</p>
		<p>21.未经本公司的许可，以任何目的自行或授权、允许、协助任何第三人对平台内的任何信息内容进行非法获取，用于商业用途或其他任何目的。“非法获取”是指采用包括但不限于“蜘蛛”(spider)程序、爬虫程序、拟人程序等非真实用户或避开、破坏技术措施等非正常浏览的手段、方式，读取、复制、转存、获得数据和信息内容的行为。
		</p>
		<p>22.为任何注册用户或非注册用户提供自动登录到消防设施操作员实操仿真学习软件平台、代办或协助他人代办身份认证服务的或代售身份认证所需的相关材料或凭据等.</p>
		<p>23.其他任何导致或可能导致本公司与第三方产生纠纷、争议或诉讼的行为。</p>
		<p class="head"> 九、特别规定</p>
		<p>1.用户如违反本协议第八条，消防设施操作员实操仿真学习软件有权在任何时候不经任何事先通知暂停或终止向该用户提供服务。</p>
		<p>2.用户有下列行为或存在下述情形的，消防设施操作员实操仿真学习软件在发现或接到投诉后，有权采取冻结用户账户或以其他方式暂停向该用户提供服务，并要求用户承担相应的损害赔偿责任： </p>
		<p>（1）发布了涉及广告、传销、直销等内容</p>
		<p>（2）发布了涉及色情、淫秽内容 </p>
		<p>（3）发布了涉及违法/政治敏感内容 </p>
		<p>（4）发布虚假信息</p>
		<p>（5）利用消防设施操作员实操仿真学习软件提供的服务索取他人隐私</p>
		<p>（6）发布涉及人身攻击或其他侵害他人权益的内容 </p>
		<p>（7）发布未成年人工作信息 </p>
		<p>（8）以培训费、服装费等名义骗取求职者财物 </p>
		<p>（9）骚扰其他用户</p>
		<p>（10）发布不符合消防设施操作员实操仿真学习软件相关服务性质的信息，如鸡汤、段子、水贴等</p>
		<p>（11）利用本平台可能存在的漏洞恶意充值、获取道具等虚拟产品或服务</p>
		<p>（12）在本平台以外的任何第三方平台（包括但不限于淘宝、闲鱼等）售卖道具等虚拟产品或服务的行为</p>
		<p>（13）通过第三方平台或渠道（如淘宝店铺等）购买道具等虚拟产品或服务</p>
		<p>（14）其他违反法律法规或国家政策以及损害消防设施操作员实操仿真学习软件及其合法用户之合法权益的行为</p>   
		<p class="head">十、第三方软件或技术</p>
		<p>1.本软件可能会使用第三方软件或技术（包括本软件可能使用的开源代码和公共领域代码等，下同），这种使用已经获得合法授权。</p>
		<p>2.本软件如果使用了第三方的软件或技术，消防设施操作员实操仿真学习软件将按照相关法规或约定，对相关的协议或其他文件，可能通过本协议附件、在本软件安装包特定文件夹中打包等形式进行展示，它们可能会以“软件使用许可协议”、“授权协议”、“开源代码许可证”或其他形式来表达。前述通过各种形式展现的相关协议或其他文件，均是本协议不可分割的组成部分，与本协议具有同等的法律效力，您应当遵守这些要求。如果您没有遵守这些要求，该第三方或者国家机关可能会对您提起诉讼、罚款或采取其他制裁措施，并要求消防设施操作员实操仿真学习软件给予协助，您应当自行承担法律责任。
		</p>
		<p>3. 如因本软件使用的第三方软件或技术引发的任何纠纷，应由该第三方负责解决，消防设施操作员实操仿真学习软件不承担任何责任。消防设施操作员实操仿真学习软件不对第三方软件或技术提供客服支持，若您需要获取支持，请与第三方联系。</p>
		<p class="head">十一、其他</p>
		<p>1.您使用本软件即视为您已阅读并同意受本协议的约束。消防设施操作员实操仿真学习软件有权在必要时修改本协议条款。您可以在本软件的最新版本中查阅相关协议条款。本协议条款变更后，如果您继续使用本软件，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用本软件。
		</p>
		<p>2. 本协议签订地为中华人民共和国上海市。</p>
		<p>3. 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</p>
		<p>4. 若您和消防设施操作员实操仿真学习软件之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。</p>
		<p>5. 本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。</p>
		<p>6. 本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。（正文完）</p>
		<p class="head">消防设施操作员实操仿真学习软件</p>
	</div>
</template>

<script>
	export default {
		beforeCreate() {
			document.title = '用户协议'
		}
	}
</script>

<style>
	.text {
		padding: 15px;
		font-size: 14px;
		color: #333;
	}

	.text p {
		line-height: 1.6;
	}

	.text .head {
		font-weight: 500;
	}

	.text .space2 {
		text-indent: 2em;
	}

	.text .space4 {
		text-indent: 4em;
	}
</style>
